import { IndexBody } from './IndexBody';
import '../styles/NewIndexPage.css';
import { useState, useEffect } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { updateColors, useTheme } from '../hooks/ThemeContext';
import * as Sentry from '@sentry/react';


function Index({firstTimer = false}) {
    const [currUser, setCurrentUser] = useState({});
    const [currErrMsg, setCurrErrMsg] = useState("");
    const [isLoaded, setIsLoaded] = useState(false); //backend response complete or not
    const {setTheme} = useTheme();
    const [searchParams] = useSearchParams();
    const [totalJobSize, setTotalJobSize] = useState(null);
    
    const navigate = useNavigate();

    useEffect(() => {
        const fetchIndex = async () => {
            try {
                const response = await fetch(`/api`);
                const data = await response.json();

                if (data.colors) {
                    localStorage.setItem('theme-colors', JSON.stringify(data.colors));
                    updateColors(data.colors, setTheme);
                }

                if (data.total_jobs_size !== undefined && data.total_jobs_size !== null) {
                    setTotalJobSize(data.total_jobs_size);
                }

                if (data.should_redirect && searchParams.get("noredir") !== "1") {
                    navigate("/results");
                }

                if (data.redirect_admin) {
                    navigate("/admin");
                }

                if (data.user) {
                    setCurrentUser(data.user);
                } else {
                    setCurrentUser({ 'na': true });
                }

                if (data.error_message) {
                    setCurrErrMsg(data.error_message);
                }
            } catch (err) {
                setCurrentUser({ 'error': true });
                setCurrErrMsg("Network error. Please reload the page.");
                Sentry.captureException(err);
            } finally {
                setIsLoaded(true);
            }
        };
        fetchIndex();
      }, []);
    return (<>
        {(firstTimer && !isLoaded) ?
        <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center',  height: '100vh', width: '100vw'}}>
          <div className='spinner'></div>
        </div>
        :
        <>
          <IndexBody
              user={currUser}
              errormessage={currErrMsg}
              totalJobSize={totalJobSize}
            />
        </>}
        </>);
}

export {Index};